import { TimelineParty } from './enums/timeline-party.enum';

export enum TimelineActionType {
    SellerDataAndDocumentRequest,
    SellerEngagementDocument,
    SellerTeaserApproval,
    SellerCustomProcessDuration,
    SellerCustomSelectDataNdaTerms,
    SellerCustomSelectDueDiligenceNdaTerms,
    SellerCustomMeetingAvailability,
    SellerBuyerSelectionIdNda,
    SellerBuyerSelectionStage2Nda,
    SellerBuyerSelectionDetailedFinancialModel,
    SellerBuyerSelectionMeetings,
    SellerBuyerSelectionStage3Nda,
    BuyerDocumentExecution,
    BuyerExpressionOfInterest,
    BuyerExpressionOfInterestWithRange,
    BuyerReviewDocument,
    BuyerUploadDocument,
    BuyerScheduleMeeting,
    BuyerLoiInformation,
    VetValueBuyerSelectionAndTeaserPosting,
    SellerMeetingScheduling,
}

export enum BuyerActionTypeGroups {
    DocumentExecution,
    ExpresstionOfInterest,
    ReviewDocument,
    UploadDocument,
    Custom,
}

export enum SellerActionTypeGroups {
    DataAndDocumentRequest,
    EngagementDocument,
    BuyerSelection,
    Custom,
    NdaTermsSelection,
    TeaserApproval,
}

export enum VetValueActionTypeGroups {
    BuyerSelectionAndTeaserPosting,
}

export enum SellerAndBuyerActionTypeGroups {
    BuyerSelection,
    NdaTermsSelection,
    MeetingScheduling,
}

export interface ActionTypeDefinition {
    id: TimelineActionType;
    party: TimelineParty;
    group: BuyerActionTypeGroups | SellerActionTypeGroups | VetValueActionTypeGroups | SellerAndBuyerActionTypeGroups;
    name: string;
    oppositePartyName?: string;
}

export const MarketplaceEventActionTypeList: ActionTypeDefinition[] = [
    {
        id: TimelineActionType.SellerDataAndDocumentRequest,
        party: TimelineParty.Seller,
        group: SellerActionTypeGroups.DataAndDocumentRequest,
        name: 'Data & Docs Request',
    },
    {
        id: TimelineActionType.SellerEngagementDocument,
        party: TimelineParty.Seller,
        group: SellerActionTypeGroups.EngagementDocument,
        name: 'Engagement Document',
    },
    {
        id: TimelineActionType.SellerTeaserApproval,
        party: TimelineParty.Seller,
        group: SellerActionTypeGroups.TeaserApproval,
        name: 'Teaser Approval',
    },
    {
        id: TimelineActionType.SellerCustomProcessDuration,
        party: TimelineParty.Seller,
        group: SellerActionTypeGroups.Custom,
        name: 'Process Duration',
    },
    {
        id: TimelineActionType.SellerCustomSelectDueDiligenceNdaTerms,
        party: TimelineParty.Seller,
        group: SellerActionTypeGroups.NdaTermsSelection,
        name: 'Select Stage Due Diligence NDA Terms',
    },
    {
        id: TimelineActionType.SellerCustomMeetingAvailability,
        party: TimelineParty.Seller,
        group: SellerActionTypeGroups.Custom,
        name: 'Metting Availability',
    },
    {
        id: TimelineActionType.SellerBuyerSelectionStage2Nda,
        party: TimelineParty.Seller,
        group: SellerActionTypeGroups.BuyerSelection,
        name: 'Buyer Selection Stage 2 NDA',
    },
    {
        id: TimelineActionType.SellerBuyerSelectionDetailedFinancialModel,
        party: TimelineParty.SellerAndBuyer,
        group: SellerAndBuyerActionTypeGroups.BuyerSelection,
        name: 'Buyer Selection Detailed Financial Model',
    },
    {
        id: TimelineActionType.SellerBuyerSelectionMeetings,
        party: TimelineParty.Seller,
        group: SellerActionTypeGroups.BuyerSelection,
        name: 'Buyer Selection Meetings',
    },
    {
        id: TimelineActionType.SellerBuyerSelectionStage3Nda,
        party: TimelineParty.Seller,
        group: SellerActionTypeGroups.BuyerSelection,
        name: 'Buyer Selection Stage 3 NDA',
    },
    {
        id: TimelineActionType.BuyerDocumentExecution,
        party: TimelineParty.Buyer,
        group: BuyerActionTypeGroups.DocumentExecution,
        name: 'Document Execution',
    },
    {
        id: TimelineActionType.BuyerExpressionOfInterest,
        party: TimelineParty.Buyer,
        group: BuyerActionTypeGroups.ExpresstionOfInterest,
        name: 'Expression of Interest',
    },
    {
        id: TimelineActionType.BuyerExpressionOfInterestWithRange,
        party: TimelineParty.Buyer,
        group: BuyerActionTypeGroups.ExpresstionOfInterest,
        name: 'Expression of Interest with Range',
    },
    {
        id: TimelineActionType.BuyerReviewDocument,
        party: TimelineParty.Buyer,
        group: BuyerActionTypeGroups.ReviewDocument,
        name: 'Review Document',
    },
    {
        id: TimelineActionType.BuyerUploadDocument,
        party: TimelineParty.Buyer,
        group: BuyerActionTypeGroups.UploadDocument,
        name: 'Upload Document',
    },
    {
        id: TimelineActionType.BuyerScheduleMeeting,
        party: TimelineParty.Buyer,
        group: BuyerActionTypeGroups.Custom,
        name: 'Schedule Meeting',
    },
    {
        id: TimelineActionType.BuyerLoiInformation,
        party: TimelineParty.Buyer,
        group: BuyerActionTypeGroups.Custom,
        name: 'LOI Information',
    },
    {
        id: TimelineActionType.VetValueBuyerSelectionAndTeaserPosting,
        party: TimelineParty.VetValue,
        group: VetValueActionTypeGroups.BuyerSelectionAndTeaserPosting,
        name: 'Buyer Selection / Teaser Posting',
    },
    {
        id: TimelineActionType.SellerBuyerSelectionIdNda,
        party: TimelineParty.SellerAndBuyer,
        group: SellerAndBuyerActionTypeGroups.BuyerSelection,
        name: 'Buyer Selection ID NDA',
        oppositePartyName: 'Document Execution',
    },
    {
        id: TimelineActionType.SellerCustomSelectDataNdaTerms,
        party: TimelineParty.SellerAndBuyer,
        group: SellerAndBuyerActionTypeGroups.NdaTermsSelection,
        name: 'Select Stage Data NDA Terms',
    },
    {
        id: TimelineActionType.SellerMeetingScheduling,
        party: TimelineParty.SellerAndBuyer,
        group: SellerAndBuyerActionTypeGroups.MeetingScheduling,
        name: 'Meeting Scheduling',
    },
];

export const BuyerLinkActionGroupOptions = [
    {
        id: BuyerActionTypeGroups.DocumentExecution,
        party: TimelineParty.Buyer,
        name: 'Document Execution',
        isImplemented: true,
    },
    {
        id: BuyerActionTypeGroups.ExpresstionOfInterest,
        party: TimelineParty.Buyer,
        name: 'Expression of Interest',
        isImplemented: true,
    },
    {
        id: BuyerActionTypeGroups.ReviewDocument,
        party: TimelineParty.Buyer,
        name: 'Review Document',
        isImplemented: true,
    },
    {
        id: BuyerActionTypeGroups.UploadDocument,
        party: TimelineParty.Buyer,
        name: 'Upload Information/Document',
        isImplemented: true,
    },
    {
        id: BuyerActionTypeGroups.Custom,
        party: TimelineParty.Buyer,
        name: 'Custom',
        isImplemented: false,
    },
];

export const SellerLinkActionGroupOptions = [
    {
        id: SellerActionTypeGroups.DataAndDocumentRequest,
        party: TimelineParty.Seller,
        name: 'Data & Document Request',
        isImplemented: true,
    },
    {
        id: SellerActionTypeGroups.EngagementDocument,
        party: TimelineParty.Seller,
        name: 'Engagement Document',
        isImplemented: true,
    },
    // {
    //     id: SellerActionTypeGroups.BuyerSelection,
    //     party: TimelineParty.Seller,
    //     name: 'Buyer Selection',
    //     isImplemented: true,
    // },
    {
        id: SellerActionTypeGroups.TeaserApproval,
        party: TimelineParty.Seller,
        name: 'Teaser Approval',
        isImplemented: true,
    },
    {
        id: SellerActionTypeGroups.Custom,
        party: TimelineParty.Seller,
        name: 'Custom',
        isImplemented: false,
    },
];

export const VetValueLinkActionGroupOptions = [
    {
        id: VetValueActionTypeGroups.BuyerSelectionAndTeaserPosting,
        party: TimelineParty.VetValue,
        name: 'Buyer Selection / Teaser Posting',
        isImplemented: true,
    },
];

export const SellerAndBuyerLinkActionGroupOptions = [

    {
        id: SellerAndBuyerActionTypeGroups.BuyerSelection,
        party: TimelineParty.SellerAndBuyer,
        name: 'Buyer Selection',
        isImplemented: true,
    },
    {
        id: SellerAndBuyerActionTypeGroups.NdaTermsSelection,
        party: TimelineParty.SellerAndBuyer,
        name: 'Data NDA Terms Selection',
        isImplemented: true,
    },
    {
        id: SellerAndBuyerActionTypeGroups.MeetingScheduling,
        party: TimelineParty.SellerAndBuyer,
        name: 'Meeting Scheduling',
        isImplemented: true,
    },
];

export const BuyerExpressionOfInterestOptionsList = [
    {
        label: 'No need to specify range',
        value: TimelineActionType.BuyerExpressionOfInterest,
    },
    {
        label: 'Indicate value range',
        value: TimelineActionType.BuyerExpressionOfInterestWithRange,
    },
];

export const BuyerSelectionOptionsList = [
    {
        label: 'ID NDA',
        value: TimelineActionType.SellerBuyerSelectionIdNda,
    },
    /*  {
        label: 'Data NDA',
        value: TimelineActionType.SellerBuyerSelectionStage2Nda,
    },*/
    {
        label: 'Detailed Financial Model',
        value: TimelineActionType.SellerBuyerSelectionDetailedFinancialModel,
    } /*
    {
        label: 'Meetings',
        value: TimelineActionType.SellerBuyerSelectionMeetings,
    },
    {
        label: 'Due Diligence NDA',
        value: TimelineActionType.SellerBuyerSelectionStage3Nda,
    }*/,
];

export const NdaTermSelectionOptionsList = [
    {
        label: 'Data NDA Terms',
        value: TimelineActionType.SellerCustomSelectDataNdaTerms,
    },
];

export const BuyerDocumentExecutionOptionsList = [
    {
        label: 'Document Execution',
        value: TimelineActionType.BuyerDocumentExecution,
    },
    {
        label: 'Upload Document',
        value: TimelineActionType.BuyerUploadDocument,
    },
    {
        label: 'Review Document',
        value: TimelineActionType.BuyerReviewDocument,
    },
];

export const ActionsWithBuyerDocumentToSign: TimelineActionType[] = [
    TimelineActionType.SellerBuyerSelectionIdNda,
    TimelineActionType.SellerCustomSelectDataNdaTerms,
    TimelineActionType.BuyerDocumentExecution,
];
